import { ReactNode, FC } from 'react';
import { Text } from '@dodilio/ui-design-lib';
import { HeroShell } from '../../components/HeroShell';

interface AcceptInviteLayoutProps {
    children: ReactNode;
}

const AcceptInvitePane = () => (
    <>

        <h1
            style={{
                fontSize: 'clamp(22px, 2.6vw, 28px)',
                fontWeight: 500,
                lineHeight: 1.06,
                letterSpacing: '-0.03em',
                margin: '0 0 18px',
                color: 'var(--gray-12)',
            }}
        >
            Welcome to the{' '}
            <span
                style={{
                    color: 'var(--gray-11)',
                    fontWeight: 300,
                    fontSize: '0.78em',
                }}
            >
                team.
            </span>
        </h1>

        <Text
            as="p"
            size="2"
            className="heroPaneDesc"
            style={{ color: 'var(--gray-11)', margin: '0 0 22px', lineHeight: 1.5 }}
        >
            Set your password to join your colleagues on Dodil Cloud. You&apos;ll get access to the same workspace, projects, and resources.
        </Text>
    </>
);

export const AcceptInviteLayout: FC<AcceptInviteLayoutProps> = ({ children }) => {
    return (
        <HeroShell title="Join Our Cloud" leftPane={<AcceptInvitePane />}>
            {children}
        </HeroShell>
    );
};
